export const ROUTE_SIGNUP = { key: 'sign-up', path: '/sign-up', noAuth: true, tabTitle: 'Sign Up' };
export const ROUTE_VERIFY = { key: 'verification', path: '/verification', noAuth: true, tabTitle: 'Verification' };
export const ROUTE_SIGNIN = { key: 'sign-in', path: '/sign-in', noAuth: true, tabTitle: 'Sign In' };
export const ROUTE_NO_ACCOUNT_FOUND = {
  key: 'no-account',
  path: '/no-account',
  noAuth: true,
  tabTitle: 'No Account Found',
};
export const ROUTE_CHANGEPASSWORD = {
  key: 'change-password',
  path: '/change-password',
  noAuth: true,
  tabTitle: 'Change Password',
};
export const ROUTE_SETPASSWORD = { key: 'set-password', path: '/set-password', noAuth: true, tabTitle: 'Set Password' };
export const ROUTE_EXPIRATION = { key: 'expiration', path: '/expiration', noAuth: true, tabTitle: 'Expiration' };
export const ROUTE_PASSWORD_SUCCESS = {
  key: 'password-success',
  path: '/password-changed',
  noAuth: true,
  tabTitle: 'Password Changed',
};
export const ROUTE_CODE_SENT = { key: 'code-sent', path: '/code-sent', noAuth: true, tabTitle: 'Code Sent' };
export const ROUTE_UNSUBSCRIBE_EMAILS = {
  key: 'unsubscribe-emails',
  path: '/unsubscribe-emails',
  noAuth: true,
  tabTitle: 'Unsubscribe Emails',
};
export const ROUTE_PLANS_PUBLIC = { key: 'plans', path: '/plans', noAuth: true, tabTitle: 'Plans' };

export const ROUTE_PROFILE = { key: 'profile', path: '/profile', tabTitle: 'Profile' };
export const ROUTE_ORG_SETTINGS = {
  key: 'org-settings',
  path: '/org-settings',
  tabTitle: 'Organization Settings',
};
export const ROUTE_ORG_REGISTRATION_FORM = {
  key: 'register-organization',
  path: '/register-organization',
  tabTitle: 'Register Organization',
};
export const ROUTE_ORG_TEAMING_FORM = {
  key: 'teaming-organization',
  path: '/teaming-organization',
  tabTitle: 'Teaming Organization',
};
export const ROUTE_MIGRATION = { key: 'migration', path: '/extra-info', tabTitle: 'Extra Info' };
export const ROUTE_BILLING = { key: 'billing', path: '/billing', tabTitle: 'Billing' };
export const ROUTE_CHECKOUT = { key: 'checkout', path: '/checkout', tabTitle: 'Checkout' };
export const ROUTE_CHECKOUT_DETAILS = { key: 'checkout', path: '/checkout/:type?/:id?', tabTitle: 'Checkout' };
export const ROUTE_SUCCESS_PAYMENT = {
  key: 'subscription-success',
  path: '/subscription-success/:subscriptionId',
  tabTitle: 'Subscription Success',
};
export const ROUTE_PLANS_PRIVATE = { key: 'plans-private', path: '/_plans', tabTitle: 'Plans' };

export const ROUTE_EZ_SEARCH = { key: 'search', path: '/search', tabTitle: 'EZ Search' };

//
export const ROUTE_DASHBOARD = {
  key: 'dashboard',
  path: '/dashboard',
  tabTitle: 'Dashboard',
  icon: 'IconDashboard',
  component: 'DashboardNew',
  subscribedOnly: true,
  showMenu: true,
  keyPermission: 'dashboard-visibility',
  onboardingDes: 'Here you will find a summary of your activity',
};

export const ROUTE_DEMO_DASHBOARD = {
  key: 'demo-dashboard',
  path: '/ddashboard',
  tabTitle: 'Demo Dashboard',
  icon: 'IconDashboard',
  component: 'DemoDashboard',
  subscribedOnly: true,
  showMenu: true,
  keyPermission: 'demo-dashboard-visibility',
  onboardingDes: 'Here you will find a summary of your activity',
};
//
export const ROUTE_CALENDAR = {
  key: 'Calendar',
  path: '/calendar',
  tabTitle: 'Calendar',
  icon: 'IconCalendar',
  component: 'Calendar',
  subscribedOnly: true,
  showMenu: true,
  keyPermission: 'calendar-visibility',
};

export const ROUTE_VIDEO_LIBRARY = {
  key: 'video-library',
  path: '/video-library',
  tabTitle: 'Video Library',
  icon: 'IconVideo',
  component: 'VideoLibrary',
};

export const ROUTE_VIDEO_DETAIL = {
  key: 'video-detail',
  path: '/video-detail/:id',
  tabTitle: 'Video Detail',
  icon: 'IconVideo',
  component: 'VideoDetail',
};

export const ROUTE_SAVED_SEARCHES = {
  key: 'saved-searches',
  path: '/saved-searches',
  tabTitle: 'Saved Searches',
  icon: 'IconSavedSearches',
  component: 'SavedSearches',
  showMenu: true,
  keyPermission: 'saved-searches-visibility',
  capabilityKey: 'saved-searches',
  onboardingDes: 'Find all your saved searches in one place',
};

export const ROUTE_TEAMING_OPPORTUNITIES_DETAILS = {
  key: 'teaming-opportunities',
  path: '/teaming-opportunities/:id',
  tabTitle: 'Teaming Opportunities',
};

export const ROUTE_TEAMING_OPPORTUNITIES_EXPLORER = {
  key: 'teaming-opportunities',
  path: '/teaming-opportunities/browser/explorer',
  tabTitle: 'Teaming Opportunities',
};

export const ROUTE_OPEN_PURSUITS = {
  key: 'teaming-opportunities',
  path: '/open-pursuits',
  tabTitle: 'Open Pursuits',
  component: 'OpenPursuits',
};

export const ROUTE_TEAMING_OPPORTUNITIES = {
  key: 'teaming-opportunities',
  path: '/teaming-opportunities',
  tabTitle: 'Teaming Opportunities',
  icon: 'IconTeamingOpportunities',
  component: 'TeamingOpportunities',
  nested: [ROUTE_TEAMING_OPPORTUNITIES_EXPLORER, ROUTE_TEAMING_OPPORTUNITIES_DETAILS],
  showMenu: true,
  keyPermission: 'teaming-opportunities-visibility',
  onboardingDes: 'Find out if there are any opportunities to team up',
};

export const ROUTE_PURSUIT_DETAILS = {
  key: 'Pursuits',
  path: '/pursuits/:id',
  tabTitle: 'Pursuits',
};
export const ROUTE_MY_PURSUITS = {
  key: 'my-pursuits',
  path: '/pursuits',
  tabTitle: 'Pursuits',
  icon: 'IconPursuits',
  component: 'MyPursuits',
  subscribedOnly: true,
  showMenu: true,
  nested: [ROUTE_PURSUIT_DETAILS],
  keyPermission: 'my-pursuits-visibility',
  onboardingDes: "A list of your pursuits and the stage they're in",
};

export const ROUTE_PIPELINES = {
  key: 'pipelines',
  path: '/pipelines',
  tabTitle: 'Pipelines',
  icon: 'IconPipelines',
  component: 'Pipelines',
  subscribedOnly: true,
  showMenu: true,
  keyPermission: 'pipelines-visibility',
  onboardingDes: 'Create workflows for your pursuits and prospects',
};

export const ROUTE_TASKS = {
  key: 'pipelines-pursuits-tasks',
  path: '/tasks',
  tabTitle: 'Tasks',
  icon: 'IconTasks',
  component: 'Tasks',
  subscribedOnly: true,
  showMenu: true,
  keyPermission: 'tasks-visibility',
  onboardingDes: 'Keep track of your work and pipelines with tasks',
};

export const ROUTE_PERSONAL_TASKS = {
  key: 'personal-tasks',
  path: '/personal-tasks',
  tabTitle: 'Personal Tasks',
  icon: 'IconPersonalTasks',
  component: 'PersonalTasks',
  subscribedOnly: true,
  showMenu: true,
  keyPermission: 'personal-tasks-visibility',
  onboardingDes: 'Create, edit, delete, and manage your personal tasks while keeping track of their progress',
};

export const ROUTE_VENDORS_DETAILS = {
  key: 'vendors',
  path: '/vendors/:id',
  tabTitle: 'Vendors',
  keyPermission: 'vendors-visibility',
};
export const ROUTE_LOCAL_VENDORS_DETAILS = {
  key: 'local-vendors',
  path: '/vendors/local-vendors/:id',
  tabTitle: 'Local Vendors',
  keyPermission: 'vendors-visibility',
};

export const ROUTE_VENDORS = {
  key: 'vendors',
  path: '/vendors',
  tabTitle: 'Vendors',
  icon: 'IconVendors',
  component: 'Vendors',
  nested: [ROUTE_VENDORS_DETAILS, ROUTE_LOCAL_VENDORS_DETAILS],
  showMenu: true,
  keyPermission: 'vendors-visibility',
  onboardingDes: 'Find summaries and contact information of vendors',
};

export const ROUTE_VENDORS_MANAGEMENT_LIST = {
  key: 'vendors-management-list',
  path: '/vendors-management-list',
  tabTitle: 'Vendors Management',
  // icon: 'IconVendors',
  //component: 'Vendors',
};

export const ROUTE_VENDORS_MANAGEMENT_DETAILS = {
  key: 'vendor-details',
  path: '/vendor-details/:id',
  tabTitle: 'Vendor Management',
};

export const ROUTE_VENDORS_MANAGEMENT = {
  key: 'vendor-management',
  path: '/vendors-management',
  tabTitle: 'Vendor Management',
  icon: 'IconVendors',
  component: 'Vendors',
  showMenu: true,
  keyPermission: 'vendor-management-visibility',
  onboardingDes: 'Manage all your potential partners from here',
  nested: [ROUTE_VENDORS_MANAGEMENT_LIST, ROUTE_VENDORS_MANAGEMENT_DETAILS],
};

export const ROUTE_MY_FAVORITES = {
  key: 'my-favorites',
  path: '/my-favorites',
  tabTitle: 'My Favorites',
  icon: 'IconStar',
  component: 'MyFavorites',
  showMenu: true,
  keyPermission: 'my-favorites-visibility', // need favorite permissions?
  onboardingDes: 'Manage your favorite opportunities here',
};

export const ROUTE_EXPORTS = {
  key: 'exports',
  path: '/exports',
  tabTitle: 'Exports',
  icon: 'IconExports',
  component: 'Exports',
  showMenu: true,
  keyPermission: 'exports-visibility',
  onboardingDes: 'Check all your exports here',
};

//
export const ROUTE_CONTRACT_OPPORTUNITIES_DETAILS = {
  key: 'federal-contract-opportunities',
  path: '/contract-opportunities/:id',
  tabTitle: 'Federal Contract Opportunities',
  keyPermission: 'contract-opportunities-visibility',
};
export const ROUTE_CONTRACT_OPPORTUNITIES = {
  key: 'federal-contract-opportunities',
  path: '/contract-opportunities',
  tabTitle: 'Federal Contract Opportunities',
  icon: 'IconContractOpportunities',
  component: 'ContractOpportunities',
  nested: [ROUTE_CONTRACT_OPPORTUNITIES_DETAILS],
  showMenu: true,
  keyPermission: 'contract-opportunities-visibility',
  onboardingDes: 'Search across millions of contract opportunities',
};

//
export const ROUTE_GRANT_OPPORTUNITIES_DETAILS = {
  key: 'federal-grant-opportunities',
  path: '/grant-opportunities/:id',
  tabTitle: 'Federal Grant Opportunities',
  keyPermission: 'grant-opportunities-visibility',
};
export const ROUTE_GRANT_OPPORTUNITIES = {
  key: 'federal-grant-opportunities',
  path: '/grant-opportunities',
  tabTitle: 'Federal Grant Opportunities',
  icon: 'IconBidReady',
  component: 'GrantOpportunities',
  nested: [ROUTE_GRANT_OPPORTUNITIES_DETAILS],
  showMenu: true,
  keyPermission: 'grant-opportunities-visibility',
  onboardingDes: 'Explore and find the latest grant opportunities',
};

export const ROUTE_NSN_OPPORTUNITIES = {
  key: 'Federal NSN Opportunities',
  path: '/nsn-opportunities',
  tabTitle: 'Federal NSN Opportunities',
  icon: 'IconNsnOpportunities',
  component: 'NsnOpportunities',
  showMenu: true,
  keyPermission: 'nsn-opportunities-visibility',
  onboardingDes: 'Find Opportunities from the Department of Defense',
};

export const ROUTE_STATE_LOCAL_CONTRACT_OPPORTUNITIES_DETAILS = {
  key: 'state-local-contract-opportunities',
  path: '/state-local-contract-opportunities/:id',
  tabTitle: 'State & Local Contract Opportunities',
  keyPermission: 'state-local-contract-opportunities-visibility',
};
export const ROUTE_STATE_LOCAL_CONTRACT_OPPORTUNITIES = {
  key: 'state-local-contract-opportunities',
  path: '/state-local-contract-opportunities',
  tabTitle: 'State & Local Contract Opportunities',
  icon: 'IconLocalStateContractOpportunities',
  component: 'StateLocalContractOpportunities',
  nested: [ROUTE_STATE_LOCAL_CONTRACT_OPPORTUNITIES_DETAILS],
  showMenu: true,
  keyPermission: 'state-local-contract-opportunities-visibility',
  onboardingDes: 'Search across millions of state & local contract opportunities',
};

export const ROUTE_STATE_LOCAL_FORECASTS_DETAILS = {
  key: 'state-local-forecasts',
  path: '/state-local-forecasts/:id',
  tabTitle: 'State & Local Forecasts',
  keyPermission: 'state-local-contract-opportunities-visibility',
};
export const ROUTE_STATE_LOCAL_FORECASTS = {
  key: 'state-local-forecasts',
  path: '/state-local-forecasts',
  tabTitle: 'State & Local Forecasts',
  icon: 'IconLocalStateForecasts',
  component: 'StateLocalForecasts',
  nested: [ROUTE_STATE_LOCAL_FORECASTS_DETAILS],
  showMenu: true,
  keyPermission: 'state-local-contract-opportunities-visibility',
  onboardingDes: 'Search across state & local procurement forecasts',
};

//
export const ROUTE_CONTRACT_AWARDS_DETAILS = {
  key: 'contract-awards',
  path: '/contract-awards/:id',
  tabTitle: 'Contract Awards',
  keyPermission: 'contract-awards-visibility',
};
export const ROUTE_GRANT_AWARDS_DETAILS = {
  key: 'contract-awards',
  path: 'https://www.usaspending.gov/award/:id',
  tabTitle: 'Grant Awards',
  keyPermission: 'contract-awards-visibility',
};
export const ROUTE_CONTRACT_AWARDS = {
  key: 'contract-awards',
  path: '/contract-awards',
  tabTitle: 'Contract Awards',
  icon: 'IconContractAwards',
  component: 'ContractAwards',
  nested: [ROUTE_CONTRACT_AWARDS_DETAILS],
  showMenu: true,
  keyPermission: 'contract-awards-visibility',
  onboardingDes: 'Stay in the loop with the latest contracts awarded',
};

//
export const ROUTE_FEDERAL_AGENTS_DETAILS = {
  key: 'federal-agents',
  path: '/federal-agents/:id',
  tabTitle: 'Federal Agents',
  keyPermission: 'federal-agents-visibility',
};
export const ROUTE_FEDERAL_AGENTS = {
  key: 'federal-agents',
  path: '/federal-agents',
  tabTitle: 'Federal Agents',
  icon: 'IconFederalAgents',
  component: 'FederalAgents',
  subscribedOnly: true,
  nested: [ROUTE_FEDERAL_AGENTS_DETAILS],
  showMenu: true,
  keyPermission: 'federal-agents-visibility',
  onboardingDes: 'Find contact info for thousands of Federal Agents',
};

//
export const ROUTE_AGENCIES_OFFICES_DETAILS = {
  key: 'federal-agencies-offices',
  path: '/agencies-offices/:id',
  tabTitle: 'Federal Agencies & Offices',
  keyPermission: 'federal-agencies-offices-visibility',
};
export const ROUTE_AGENCIES_OFFICES = {
  key: 'federal-agencies-offices',
  path: '/agencies-offices',
  tabTitle: 'Federal Agencies & Offices',
  icon: 'IconLocation',
  component: 'FederalAgenciesAndOffices',
  nested: [ROUTE_AGENCIES_OFFICES_DETAILS],
  showMenu: true,
  keyPermission: 'federal-agencies-offices-visibility',
  onboardingDes: 'All opportunities and funding info for each agency',
};

//
export const ROUTE_GOVERMENT_FILES_DETAILS = {
  key: 'government-files',
  path: '/government-files/:id',
  tabTitle: 'Government Files',
  keyPermission: 'government-files-visibility',
};
export const ROUTE_GOVERMENT_FILES = {
  key: 'government-files',
  path: '/government-files',
  tabTitle: 'Government Files',
  icon: 'IconGovermentFiles',
  component: 'GovermentFiles',
  nested: [ROUTE_GOVERMENT_FILES_DETAILS],
  showMenu: true,
  keyPermission: 'government-files-visibility',
  onboardingDes: 'Read the latest documents from government sources',
};

//
export const ROUTE_CODE_CATEGORIES_DETAILS = {
  key: 'code-categories',
  path: '/code-categories/:id',
  tabTitle: 'Industry Classification Codes',
  keyPermission: 'code-categories-visibility',
};
export const ROUTE_CODE_CATEGORIES = {
  key: 'code-categories',
  path: '/code-categories',
  tabTitle: 'Industry Classification Codes',
  icon: 'IconCodeCategories',
  component: 'CodeCategories',
  nested: [ROUTE_CODE_CATEGORIES_DETAILS],
  showMenu: true,
  keyPermission: 'code-categories-visibility',
  onboardingDes: 'Opportunities and relevant info by Industry Code',
};

export const ROUTE_RELEASES = {
  key: 'Releases',
  path: '/releases',
  tabTitle: 'Releases',
  icon: 'IconQuoteRequests',
  component: 'Releases',
  showMenu: false,
  keyPermission: 'dashboard-visibility',
};

export const ROUTE_LMS = {
  key: 'learning-center',
  path: 'none',
  tabTitle: 'Learning Center',
  function: 'goToLearnWorlds',
  icon: 'IconLearningCenter',
  component: 'Releases',
  showMenu: true,
  keyPermission: 'learn-center-visibility',
};

export const ROUTE_OVERVIEW = {
  key: 'Overview',
  path: '/client-portal-overview',
  tabTitle: 'Overview',
  icon: 'IconOverview',
  component: 'Business',
  showMenu: true,
  keyPermission: 'overview-visibility',
  onboardingDes: 'Determine the current state of your organization',
};

export const ROUTE_FORMS = {
  key: 'Forms',
  menuTitle: 'Forms',
  path: '/client-portal-forms',
  tabTitle: 'Forms',
  icon: 'IconForms',
  component: 'Business',
  showMenu: true,
  keyPermission: 'forms-visibility',
  capabilityKey: 'forms',
  onboardingDes: 'Visualize all the forms you have been assigned',
};

export const ROUTE_MARKETING_SAP_FORM = {
  key: 'marketing-sap-form',
  menuTitle: 'SAP Form',
  path: '/client-portal-sap-form',
  tabTitle: 'SAP Form',
  icon: 'IconForms',
  component: 'Business',
  showMenu: true,
  keyPermission: 'forms-visibility',
  onboardingDes: 'complete your SAP Form',
};

export const ROUTE_FORM_DETAIL = {
  key: 'form-detail',
  path: '/client-portal/forms/:id',
  tabTitle: 'Form Detail',
  component: 'FormDetail',
};

export const ROUTE_FORM_DETAIL_V2 = {
  key: 'form-detail',
  path: '/client-portal/forms-v2/:id',
  tabTitle: 'Form Detail',
  component: 'FormDetailv2',
};

export const ROUTE_DOCUMENTS = {
  key: 'Documents',
  path: '/client-portal-documents',
  tabTitle: 'Documents',
  icon: 'IconGovermentFiles',
  component: 'Business',
  showMenu: true,
  keyPermission: 'documents-visibility',
  capabilityKey: 'view-documents',
  onboardingDes: 'Manage your shared and requested documents',
};
export const ROUTE_SUPPORT_TICKET = {
  key: 'Service Support',
  path: '/client-portal-service-support',
  tabTitle: 'Service Support',
  icon: 'IconSupport',
  component: 'Business',
  showMenu: true,
  keyPermission: 'support-tickets-visibility',
  onboardingDes: 'Visualize your opened and closed support tickets',
};

export const ROUTE_QUOTE_REQUESTS = {
  key: 'Requests',
  path: '/quote-requests',
  tabTitle: 'Quote Requests',
  icon: 'IconQuoteRequests',
  component: 'QuoteRequests',
  showMenu: true,
  keyPermission: 'quote-requests-visibility',
  onboardingDes:
    'In this section you will find all the solicitations that you have requested a quote for and be able to proceed once you receive a response from the USFCR team.',
};

export const ROUTE_ONBOARDING_MEETING = {
  key: 'Live Training',
  path: '/onboarding-meeting',
  tabTitle: 'Live Training',
  icon: 'IconOnboardingMeeting',
  component: 'OnboardingMeeting',
  showMenu: true,
  keyPermission: 'onboarding-meeting-visibility',
  onboardingDes: 'Schedule an onboarding meeting with a USFCR team member',
};

export const ROUTE_ORGANIZATION_DEACTIVATED = {
  key: 'organization-deactivated',
  path: '/organization-deactivated',
  tabTitle: 'Organization Deactivated',
};

export const ROUTE_INVOICE = {
  key: 'invoice',
  path: '/invoice/:id',
  tabTitle: 'Invoice',
};

export const ROUTE_ROOT = {
  key: 'root',
  path: '/',
  tabTitle: 'Dashboard',
};

const WORK_PLACE_GROUP = {
  keyPermission: 'workplace',
  key: 'Dashboard',
  icon: 'IconNewDashboard',
  onboardingDes: 'This is the place were you can organize your work and follow up on potential opportunities.',
  items: [
    ROUTE_DASHBOARD,
    ROUTE_DEMO_DASHBOARD,
    ROUTE_CALENDAR,
    ROUTE_PERSONAL_TASKS,
    ROUTE_MY_FAVORITES,
    ROUTE_EXPORTS,
    ROUTE_OVERVIEW,
    ROUTE_SUPPORT_TICKET,
    ROUTE_ONBOARDING_MEETING,
    ROUTE_RELEASES,

    // ROUTE_OPEN_PURSUITS,
  ],
};

const REGISTRATION_GROUP = {
  keyPermission: 'registration', // changed from workplace
  key: 'Registration',
  icon: 'IconPersonalTasks',
  onboardingDes: 'Complete your registration to access the platform',
  items: [ROUTE_FORMS],
};

const DISCOVERY_GROUP = {
  keyPermission: 'discovery',
  key: 'Market Research',
  icon: 'IconMarketResearch',
  onboardingDes:
    'In this section you will find millions of documents with contracting opportunities, vendor details and federal agent’s contact information.',
  items: [
    ROUTE_VENDORS,
    ROUTE_STATE_LOCAL_CONTRACT_OPPORTUNITIES,
    ROUTE_STATE_LOCAL_FORECASTS,
    ROUTE_CONTRACT_OPPORTUNITIES,
    ROUTE_GRANT_OPPORTUNITIES,
    ROUTE_NSN_OPPORTUNITIES,
    ROUTE_CONTRACT_AWARDS,
    ROUTE_FEDERAL_AGENTS,
    ROUTE_AGENCIES_OFFICES,
    ROUTE_GOVERMENT_FILES,
    ROUTE_CODE_CATEGORIES,
    ROUTE_PIPELINES,
    ROUTE_MY_PURSUITS,
    ROUTE_TASKS,
    ROUTE_SAVED_SEARCHES,
  ],
};

// CLIENT PORTAL
const BUSINESS_GROUP = {
  keyPermission: 'business',
  key: 'Marketing',
  icon: 'IconMarketing',
  onboardingDes: 'Turn what you do into why it matters with your capabilities statement.',
  items: [ROUTE_TEAMING_OPPORTUNITIES, ROUTE_MARKETING_SAP_FORM],
};

const KNOWLEDGE_GROUP = {
  keyPermission: 'knowledge',
  key: 'Bid Ready',
  icon: 'IconGrantOpportunities',
  onboardingDes: 'Gather and prepare all necessary information to act when an opportunity knocks.',
  items: [
    ROUTE_VENDORS_MANAGEMENT,
    ROUTE_QUOTE_REQUESTS,
    ROUTE_DOCUMENTS,
    ROUTE_LMS,
    // ROUTE_RELEASES
  ],
};

export const ROUTE_SINGUPSUBSCRIBE = {
  key: 'singup-subscribe',
  path: '/singup-subscribe',
  tabTitle: 'Signup Subscribe',
  component: 'SingupSubscribe',
};

export const ROUTE_GOVCRM_CONTACTS = {
  key: 'CRM',
  path: '/govcrm/contacts',
  tabTitle: 'CRM Contacts',
  icon: 'IconOverview',
  component: 'GovCrm',
  showMenu: true,
  keyPermission: 'crm-visibility',
  onboardingDes: 'Manage CRM contacts for your organization.',
};

const BUSINESS_DEVELOPMENT_GROUP = {
  key: 'Business Development',
  keyPermission: 'business-development',
  icon: 'IconBusiness',
  crmAccessGated: true,
  onboardingDes: 'Manage CRM contacts for your organization.',
  items: [ROUTE_GOVCRM_CONTACTS],
};

export const APP_MENU = [
  WORK_PLACE_GROUP,
  REGISTRATION_GROUP,
  DISCOVERY_GROUP,
  BUSINESS_DEVELOPMENT_GROUP,
  BUSINESS_GROUP,
  KNOWLEDGE_GROUP,
];

export const ROUTES = {
  ROUTE_SIGNUP,
  ROUTE_VERIFY,
  ROUTE_SIGNIN,
  ROUTE_NO_ACCOUNT_FOUND,
  ROUTE_CHANGEPASSWORD,
  ROUTE_SETPASSWORD,
  ROUTE_EXPIRATION,
  ROUTE_PASSWORD_SUCCESS,
  ROUTE_CODE_SENT,
  ROUTE_UNSUBSCRIBE_EMAILS,
  ROUTE_PLANS_PUBLIC,
  ROUTE_PROFILE,
  ROUTE_ORG_SETTINGS,
  ROUTE_ORG_REGISTRATION_FORM,
  ROUTE_ORG_TEAMING_FORM,
  ROUTE_MIGRATION,
  ROUTE_BILLING,
  ROUTE_CHECKOUT,
  ROUTE_CHECKOUT_DETAILS,
  ROUTE_SUCCESS_PAYMENT,
  ROUTE_PLANS_PRIVATE,
  ROUTE_EZ_SEARCH,
  ROUTE_DASHBOARD,
  ROUTE_DEMO_DASHBOARD,
  ROUTE_CALENDAR,
  ROUTE_VIDEO_LIBRARY,
  ROUTE_VIDEO_DETAIL,
  ROUTE_SAVED_SEARCHES,
  ROUTE_TEAMING_OPPORTUNITIES_DETAILS,
  ROUTE_TEAMING_OPPORTUNITIES_EXPLORER,
  ROUTE_OPEN_PURSUITS,
  ROUTE_TEAMING_OPPORTUNITIES,
  ROUTE_PURSUIT_DETAILS,
  ROUTE_MY_PURSUITS,
  ROUTE_PIPELINES,
  ROUTE_TASKS,
  ROUTE_PERSONAL_TASKS,
  ROUTE_VENDORS_DETAILS,
  ROUTE_LOCAL_VENDORS_DETAILS,
  ROUTE_VENDORS,
  ROUTE_VENDORS_MANAGEMENT_LIST,
  ROUTE_VENDORS_MANAGEMENT_DETAILS,
  ROUTE_VENDORS_MANAGEMENT,
  ROUTE_MY_FAVORITES,
  ROUTE_EXPORTS,
  ROUTE_CONTRACT_OPPORTUNITIES_DETAILS,
  ROUTE_CONTRACT_OPPORTUNITIES,
  ROUTE_GRANT_OPPORTUNITIES_DETAILS,
  ROUTE_GRANT_OPPORTUNITIES,
  ROUTE_NSN_OPPORTUNITIES,
  ROUTE_STATE_LOCAL_CONTRACT_OPPORTUNITIES_DETAILS,
  ROUTE_STATE_LOCAL_CONTRACT_OPPORTUNITIES,
  ROUTE_STATE_LOCAL_FORECASTS_DETAILS,
  ROUTE_STATE_LOCAL_FORECASTS,
  ROUTE_CONTRACT_AWARDS_DETAILS,
  ROUTE_GRANT_AWARDS_DETAILS,
  ROUTE_CONTRACT_AWARDS,
  ROUTE_FEDERAL_AGENTS_DETAILS,
  ROUTE_FEDERAL_AGENTS,
  ROUTE_AGENCIES_OFFICES_DETAILS,
  ROUTE_AGENCIES_OFFICES,
  ROUTE_GOVERMENT_FILES_DETAILS,
  ROUTE_GOVERMENT_FILES,
  ROUTE_CODE_CATEGORIES_DETAILS,
  ROUTE_CODE_CATEGORIES,
  ROUTE_RELEASES,
  ROUTE_LMS,
  ROUTE_OVERVIEW,
  ROUTE_FORMS,
  ROUTE_MARKETING_SAP_FORM,
  ROUTE_FORM_DETAIL,
  ROUTE_FORM_DETAIL_V2,
  ROUTE_DOCUMENTS,
  ROUTE_SUPPORT_TICKET,
  ROUTE_QUOTE_REQUESTS,
  ROUTE_ONBOARDING_MEETING,
  ROUTE_ORGANIZATION_DEACTIVATED,
  ROUTE_INVOICE,
  ROUTE_ROOT,
  ROUTE_SINGUPSUBSCRIBE,
  ROUTE_GOVCRM_CONTACTS,
};
